import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { AppBar, Toolbar, Badge, IconButton, Button, Hidden, Drawer, List, ListItem, Typography } from '@material-ui/core';
import { withRouter } from 'react-router'
import { useSelector } from 'react-redux';
import CartDiscardTimeController from 'helpers/CartDiscardTimeController';
import {
  Restaurant as RestaurantIcon, Person as PersonIcon, ConfirmationNumber as ConfirmationNumberIcon,
  AddShoppingCart, CardGiftcard, Menu as MenuIcon, Close as CloseIcon, Edit as EditIcon
} from '@material-ui/icons';
import Link from '@material-ui/core/Link';
import Icon from '@material-ui/core/Icon';
import VersionCheck from 'helpers/VersionCheck';
import theme from 'theme';
import { DynamicMenu } from 'components/DynamicMenu';
import { CollapsibleMenu } from 'components/CollapsibleMenu';

const { RedirectLogoURL, GiftCardsHeading, HeaderExtraText, TicketsHeading, MembershipsHeading, TicketLinkHeading,
  FoodOrderLinkHeading, DonationLinkHeading, ManageMyBookingButtonTitle, ManageMyBookingButtonShow, ShowDynamicMenuAndPages } = window['runConfig'];

const useStyles = makeStyles(theme => ({
  root: {
    '& > *': {
      margin: theme.spacing(0.3)
    },
    float: 'left',
    marginLeft: '20px',
    color: 'white',
    marginTop: '5px'
  },
  flexGrow: {
    flexGrow: 1
  },
  iconSize: {
    fontSize: "2rem"
  },
  headerText: {
    color: theme.palette.primary.contrastText,
    [theme.breakpoints.up('sm')]: {
      marginLeft: '5px'
    }
  },
  disabledlink: {
    pointerEvents: 'none'
  },
  menuItem: {
    color: theme.palette.primary.contrastText
  },
  menuItemText: {
    color: theme.palette.primary.contrastText,
    fontSize: 14,
    marginLeft: 10,
    marginTop: 5,
    cursor: 'pointer'
  },
  linkItem: {
    color: theme.palette.primary.contrastText,
    fontSize: '14px',
    marginTop: '5px',
    cursor: 'pointer'
  },
  logo: {
    [theme.breakpoints.up('sm')]: {
      maxWidth: '200px',
      maxHeight: '50px',
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '120px',
      maxHeight: '40px',
    }
  }
}
));

const Topbar = props => {
  const { className, onSidebarOpen, ...rest } = props;

  const classes = useStyles();

  const [isMenuDrawerOpen, setIsMenuDrawerOpen] = useState(false);

  const events = useSelector(state => state.reducerShopCart.events);
  const memberships = useSelector(state => state.reducerShopCart.MembershipPackages);
  const GATickets = useSelector(state => state.reducerShopCart.GATickets);
  const managemybkng = useSelector(state => state.reducerShopCart.managemybooking);
  const orderProducts = useSelector(state => state.reducerShopCart.orderProducts);
  const giftcards = useSelector(state => state.reducerGiftCards);
  const donationProducts = useSelector(state => state.reducerShopCart.donationProducts);

  const handleClick = event => {
    if (managemybkng === false) {
      if (orderProducts && orderProducts.length > 0) {
        props.history.push('/revieworderproducts');
      }
      else
        props.history.push('/Checkout');
    }
  };

  const CountGiftCards = () => {
    let totalGFs = 0;
    if (giftcards.giftcards && giftcards.giftcards.length > 0) {
      totalGFs = giftcards.giftcards.filter(x => x.AddedToCart === true && x.CartQty > 0).map(({ CartQty }) => CartQty).reduce((sum, i) => sum + i, 0);
    }

    return totalGFs;
  }


  const eventitemcount = () => {
    if ((events == null || events.length == 0) && (memberships == null || memberships.length == 0) && (GATickets == null || GATickets.length == 0) && (orderProducts == null || orderProducts.length == 0) && (giftcards.giftcards == null || giftcards.giftcards.length == 0) && (donationProducts == null || donationProducts.length == 0))
      return 0;
    else {
      let qty = 0;
      events.forEach(event => {
        event.TourProducts.forEach(product => {
          qty += product.Quantity;
        })
      });

      GATickets.forEach(ticket => {
        qty += ticket.Quantity;
      })

      donationProducts.forEach(product => {
        qty++;
      })

      if (memberships && memberships.length > 0) {
        qty++;
      }

      orderProducts.forEach(p => {
        qty += p.Quantity;
      });

      if (giftcards.giftcards && giftcards.giftcards.length > 0) {
        qty += CountGiftCards();
      }

      return qty;
    }
  }

  const OnClickMenuLink = (path) => {
    props.history.push(path);
    setIsMenuDrawerOpen(false);
  }

  return (
    <AppBar id='vt_component_appbar' style={{ zIndex: 1000 }}>
      <Toolbar >
        <VersionCheck></VersionCheck>
        {!managemybkng ?
          <CartDiscardTimeController></CartDiscardTimeController>
          : null}


        <Hidden lgUp>
          {managemybkng ? null :
            <>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={() => setIsMenuDrawerOpen(true)}
              >
                <MenuIcon />
              </IconButton>
              <Drawer
                PaperProps={{
                  style: { backgroundColor: theme.palette.primary.main }
                }}
                open={isMenuDrawerOpen}
                onClose={() => setIsMenuDrawerOpen(false)}>
                <List key={"menu_link"}>

                  <ListItem button onClick={() => { setIsMenuDrawerOpen(false) }}>
                    <Badge variant="standard">
                      <CloseIcon className={classes.menuItem} />
                      <Typography className={classes.menuItemText}></Typography>
                    </Badge>
                  </ListItem>

                  {
                    ShowDynamicMenuAndPages ?
                      <CollapsibleMenu setIsMenuDrawerOpen={setIsMenuDrawerOpen} />
                      :
                      <>
                        {TicketsHeading && TicketsHeading != "" ?
                          <ListItem button onClick={() => OnClickMenuLink('/products')}>
                            <Badge variant="standard">
                              <ConfirmationNumberIcon className={classes.menuItem} />
                              <Typography className={classes.menuItemText}> {TicketsHeading}</Typography>
                            </Badge>
                          </ListItem> : ""}

                        {TicketLinkHeading && TicketLinkHeading != "" ?
                          <ListItem button onClick={() => OnClickMenuLink('/gatickets')}>
                            <Badge variant="standard">
                              <ConfirmationNumberIcon className={classes.menuItem} />
                              <Typography className={classes.menuItemText}>  {TicketLinkHeading}</Typography>
                            </Badge>
                          </ListItem>
                          : ""}

                        {MembershipsHeading && MembershipsHeading != "" ?
                          <ListItem button onClick={() => OnClickMenuLink('/memberships')}>
                            <Badge variant="standard">
                              <PersonIcon className={classes.menuItem} />
                              <Typography className={classes.menuItemText}>{MembershipsHeading}</Typography>
                            </Badge>
                          </ListItem> : ""}

                        {GiftCardsHeading && GiftCardsHeading != "" ?
                          <ListItem button onClick={() => OnClickMenuLink('/giftcards')}>
                            <Badge variant="standard">
                              <CardGiftcard className={classes.menuItem} />
                              <Typography className={classes.menuItemText}>{GiftCardsHeading}</Typography>
                            </Badge>
                          </ListItem> : ""}

                        {FoodOrderLinkHeading && FoodOrderLinkHeading != "" ?
                          <ListItem button onClick={() => OnClickMenuLink('/orderlocation')}>
                            <Badge variant="standard">
                              <RestaurantIcon className={classes.menuItem} />
                              <Typography className={classes.menuItemText}>{FoodOrderLinkHeading}</Typography>
                            </Badge>
                          </ListItem> : ""}

                        {DonationLinkHeading && DonationLinkHeading != "" ?
                          <ListItem button onClick={() => OnClickMenuLink('/donationareas')}>
                            <Badge variant="standard">
                              <Icon className={classes.menuItem}>volunteer_activism</Icon>
                              <Typography className={classes.menuItemText}>{DonationLinkHeading}</Typography>
                            </Badge>
                          </ListItem> : ""}

                        {!managemybkng && ManageMyBookingButtonShow ?
                          <ListItem button onClick={() => OnClickMenuLink('/findmybooking')}>
                            <Badge variant="standard">
                              <EditIcon className={classes.menuItem}></EditIcon>
                              <Typography className={classes.menuItemText}>{ManageMyBookingButtonTitle}</Typography>
                            </Badge>
                          </ListItem>
                          : ""}

                      </>
                  }


                </List>
              </Drawer>
            </>
          }
        </Hidden>

        <Hidden xsDown>
          <Link to="/" className={managemybkng ? classes.disabledlink : ''} onClick={() => { window.location.href = RedirectLogoURL; }}>
            <img
              alt="Logo"
              src={process.env.PUBLIC_URL + "/images/logos/logo.png"}
              className={(managemybkng ? classes.disabledlink : '') + ' ' + "WebsiteLogoSizeOnLargeDevices " + classes.logo}
            />

          </Link>
          <Typography className={classes.headerText} variant='body1'>{HeaderExtraText}</Typography>
        </Hidden>

        <Hidden smUp>
          <Link to="/" className={managemybkng ? classes.disabledlink : ''} onClick={() => { window.location.href = RedirectLogoURL; }}>
            <img
              alt="Logo"
              src={process.env.PUBLIC_URL + "/images/logos/logo.png"}
              className={(managemybkng ? classes.disabledlink : '') + ' ' + "WebsiteLogoSizeOnMobile " + classes.logo}
            />
            <Typography className={classes.headerText} variant='body1'>{HeaderExtraText}</Typography>
          </Link>

        </Hidden>

        <Hidden mdDown >
          {ShowDynamicMenuAndPages ? <DynamicMenu /> :

            managemybkng ? null :
              <div className={classes.root}>
                <>
                  {TicketsHeading && TicketsHeading != "" ?
                    <span>
                      <Badge variant="standard">
                        <ConfirmationNumberIcon />
                        <Link
                          className={classes.linkItem}
                          onClick={() => { props.history.push('/products'); }}>
                          {TicketsHeading}
                        </Link>
                      </Badge>
                    </span> : ""}

                  {TicketLinkHeading && TicketLinkHeading != "" ?
                    <span>
                      <Badge variant="standard">
                        <ConfirmationNumberIcon />
                        <Link className={classes.linkItem}
                          onClick={() => { props.history.push('/gatickets'); }}>
                          {TicketLinkHeading}
                        </Link>
                      </Badge>
                    </span>
                    : ""}

                  {MembershipsHeading && MembershipsHeading != "" ?
                    <span>
                      <Badge variant="standard">
                        <PersonIcon />
                        <Link
                          className={classes.linkItem}
                          onClick={() => { props.history.push('/memberships'); }}>
                          {MembershipsHeading}
                        </Link>
                      </Badge>
                    </span> : ""}

                  {GiftCardsHeading && GiftCardsHeading != "" ?
                    <span>
                      <Badge variant="standard">
                        <CardGiftcard />
                        <Link
                          className={classes.linkItem}
                          onClick={() => { props.history.push('/giftcards'); }}>
                          {GiftCardsHeading}
                        </Link>
                      </Badge>
                    </span> : ""}

                  {FoodOrderLinkHeading && FoodOrderLinkHeading != "" ?
                    <span>
                      <Badge variant="standard">
                        <RestaurantIcon />
                        <Link
                          className={classes.linkItem}
                          onClick={() => { props.history.push('/orderlocation'); }}>
                          {FoodOrderLinkHeading}
                        </Link>
                      </Badge>
                    </span> : ""}

                  {DonationLinkHeading && DonationLinkHeading != "" ?
                    <span>
                      <Badge variant="standard">
                        <Icon>volunteer_activism</Icon>
                        <Link
                          className={classes.linkItem}
                          onClick={() => { props.history.push('/donationareas'); }}>
                          {DonationLinkHeading}
                        </Link>
                      </Badge>
                    </span> : ""}
                </>
              </div>

          }
        </Hidden>

        {ShowDynamicMenuAndPages === false &&
          <div className={classes.flexGrow} />
        }

        <>
          <Hidden mdDown>
            {!managemybkng && ManageMyBookingButtonShow && ShowDynamicMenuAndPages === false ?
              <Button variant="outlined" size="small" className="ManageMyBooking" onClick={() => { props.history.push('/findmybooking'); }}>
                {ManageMyBookingButtonTitle}
              </Button>
              : ""}
          </Hidden>


          {!managemybkng ?
            <IconButton color="inherit" onClick={handleClick}>
              <Badge badgeContent={eventitemcount()} color="error">
                <AddShoppingCart className={classes.iconSize} />
              </Badge>
            </IconButton>
            : ""}
        </>
      </Toolbar>
    </AppBar >
  );
};

export default withRouter(Topbar);
